/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 15:30:41
 * @name: 工单管理-售后经理审批
 * @Description: 工单管理-售后经理审批
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\saleServiceManagerVerify.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'run_process_id',
    description: '流程id',
    required: true,
    required_message: '流程id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'act',
    description: '是否通过：OK =》是，-1 =》失败',
    required: true,
    required_message: 'act为必传项',
    match: (e) => {
      if (!['OK', -1].includes(e)) {
        return 'act值须为OK或-1';
      } else {
        return '';
      }
    }
  },
  {
    key: 'remark',
    description: '备注',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'sale_manager_check_status',
    description: '是否需要营销中心主任审批：1=》是，0=》否',
    required: true,
    required_message: 'sale_manager_check_status为必传项',
    match: (e) => {
      if (![1, 0].includes(e)) {
        return 'sale_manager_check_status须为1或0';
      } else {
        return '';
      }
    }
  },
]